import { useState, useEffect } from 'react';
import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const HP_SALE_MODULE_TEST_NAME = 'HP_SaleModuleUX_March2026';

export const isHpSaleModuleVariant = (): boolean =>
    getAbTestV2(HP_SALE_MODULE_TEST_NAME)?.variant === 'variant';

export const useIsHpSaleModuleVariant = (): boolean => {
    const [isVariant, setIsVariant] = useState(false);
    useEffect(() => {
        setIsVariant(isHpSaleModuleVariant());
    }, []);
    return isVariant;
};

export const trackHpSaleModuleTest = (): void => {
    trackAbTestV2Variant(HP_SALE_MODULE_TEST_NAME);
};
